var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-select',{attrs:{"options":_vm.options,"reduce":(label) => label.code,"placeholder":_vm.placeholder,"size":"lg","multiple":_vm.multiple},model:{value:(_vm.data),callback:function ($$v) {_vm.data=$$v},expression:"data"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }